export default function LogOutIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' fill='none'>
      <path
        d='m12.75 5.25-1.057 1.058 1.934 1.942H6v1.5h7.627l-1.934 1.935 1.057 1.065L16.5 9l-3.75-3.75ZM3 3.75h6v-1.5H3c-.825 0-1.5.675-1.5 1.5v10.5c0 .825.675 1.5 1.5 1.5h6v-1.5H3V3.75Z'
        fill='#fff'
      />
    </svg>
  );
}
